import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PlatformProviders, configureProduct } from '@quoter/web-core'
import '@quoter/web-core/styles.css'
import './styles.css'
import { PRODUCT_ID, PRODUCT_NAME, TRIAL_DAYS, legalUrls } from '@/lib/product'
import { DICTIONARIES } from '@/i18n'
import { LogoMark } from '@/components/LogoMark'
import { App } from './app'

// Before anything renders: tell the shared shell which product this is.
configureProduct({
  id: PRODUCT_ID,
  name: PRODUCT_NAME,
  dictionaries: DICTIONARIES,
  LogoMark,
  trialDays: TRIAL_DAYS,
  legalUrls,
})

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Missing #root element in index.html')

createRoot(rootElement).render(
  <StrictMode>
    <PlatformProviders>
      <App />
    </PlatformProviders>
  </StrictMode>,
)
